// Copy a file's thirty-day link to the clipboard (#515).
//
// The link is our own (`…/openFileLink/f/<path>?exp=…&sig=…`), from the studio's
// link cache, and it may need a round trip to the `fileLinks` callable before
// it exists. That matters here because Safari only lets a page write the
// clipboard inside the click that asked, and an `await` ends the click. So the
// write is started synchronously with a `ClipboardItem` whose content is the
// promise of the link — which Safari and Chromium both accept — and falls back
// to waiting for the link and then `writeText` where `ClipboardItem` is not
// there (Firefox before 127, jsdom).
//
// Resolves to the link that was copied; rejects when the link could not be had
// or the browser refused the write, so the caller can say which.
export function copyLink(linkPromise, { clipboard = globalThis.navigator?.clipboard, Item = globalThis.ClipboardItem } = {}) {
  const link = Promise.resolve(linkPromise).then((url) => {
    if (!url) throw new Error('No link to copy.');
    return url;
  });
  if (!clipboard) return link.then(() => { throw new Error('This browser does not allow copying.'); });

  if (Item && typeof clipboard.write === 'function') {
    const item = new Item({ 'text/plain': link.then((url) => new Blob([url], { type: 'text/plain' })) });
    return clipboard.write([item]).then(() => link);
  }
  return link.then((url) => clipboard.writeText(url).then(() => url));
}
